import axios from "axios";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

// Shared axios instance — credentials included so the httpOnly session cookie travels
export const api = axios.create({
  baseURL: API,
  withCredentials: true,
});

export const API_URL = API;
